import React from "react";
import { useTranslation } from "next-i18next";
import { CategoryEntity, SubCategoryEntity } from "gql-types";

type AffariyetSelectPropsType = {
  name: string;
  id: string;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options: CategoryEntity[] | SubCategoryEntity[];
  defaultOption: {
    key: string;
    value: string;
    text: string;
  };
  translate: (key: string) => string;
};
function AffariyetSelect({
  name,
  id,
  handleChange,
  options,
  defaultOption,
  translate,
}: AffariyetSelectPropsType) {
  const { t: cat } = useTranslation("categories");

  if (!options || !defaultOption) {
    return null; // removing this would break the build
  }
  return (
    <div className=" w-full lg:w-2/6 custom-select">
      <select
        name={name}
        id={id}
        className="w-full border-4 bg-white border-backgroundGrey rounded-lg p-3  appearance-none outline-none"
        onChange={handleChange}
      >
        <option key={defaultOption.key} value={defaultOption.value}>
          {defaultOption.text}
        </option>
        {options.map((option: CategoryEntity | SubCategoryEntity, index: number) => (
          <option key={`option_${name}_${index}`} value={option.attributes?.name as string}>
            {cat(translate(option.attributes?.name as string))}
          </option>
        ))}
      </select>
    </div>
  );
}

export default AffariyetSelect;
